module.exports = __webpack_public_path__ + "img/Icon_Videolink_coloured_blue.58f1a291.svg";